module.exports = __webpack_public_path__ + "img/icon-favourite.ce7f9138.svg";